import { render, staticRenderFns } from "./radar_update.md?vue&type=template&id=60c7ebd9&"
import script from "./radar_update.md?vue&type=script&lang=js&"
export * from "./radar_update.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60c7ebd9')) {
      api.createRecord('60c7ebd9', component.options)
    } else {
      api.reload('60c7ebd9', component.options)
    }
    module.hot.accept("./radar_update.md?vue&type=template&id=60c7ebd9&", function () {
      api.rerender('60c7ebd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/radar/radar_update.md"
export default component.exports